import React, { useEffect, useState } from 'react';
import { addLikefeedback } from '../../redux/ducks/provider';
import { useDispatch, useSelector } from "react-redux";
import thumps_up from '../../asset/carbon_thumbs-up.png';
import thumps_up_double from '../../asset/carbon_thumbs-up-double.png';
import thumps_down from '../../asset/carbon_thumbs-down.png';
import thumps_up_filled from '../../asset/carbon_thumbs-up-filled.png';
import thumps_up_double_filled from '../../asset/carbon_thumbs-up-double-filled.png';
import thumps_down_filled from '../../asset/carbon_thumbs-down-filled.png';
import Tooltip from "@mui/material/Tooltip";
import { useRef } from "react";
import voteClasses from "./style.module.scss";

const LikeDislike = (props) => {

    const {npi} = props;
    const ref = useRef(null);

    const [hasUserLiked, sethasUserLiked] = useState(false); // Store if user liked it
    const [userGivenFeedbackType, setUserGivenFeedbackType] = useState(0);
     const dispatch = useDispatch();

         const {
             isLoading,
             providerComment
         } = useSelector((state) => state.provider);

        //  useEffect(() => {
        //     sethasUserLiked(providerComment.providerLikeFeedbackSummary?.hasUserGivenFeedback)
        //     setUserGivenFeedbackType(providerComment.providerLikeFeedbackSummary?.userGivenFeedbackType)
        //  },[providerComment])

    const [voteVersion, setVoteVersion] = useState(0);

    const handleButtonclick = async(likeValue) => {
        // action to call api
        sethasUserLiked(true);
        setUserGivenFeedbackType(likeValue)
        setVoteVersion((v) => v + 1);
        dispatch(addLikefeedback({
            npi: npi,
            feedBackType: likeValue
        }));
        sethasUserLiked(true);
    }

    return (

        <div style={styles.buttonGroup} ref={ref}>
            <button
                className={voteClasses["vote-button"]}
                style={styles.button}
                onClick={() => handleButtonclick(1)}
            >
                <Tooltip
                 title = "Disagree with Rating"

                 componentsProps={{
                    tooltip: {
                      sx: {
                        color: "black",
                        backgroundColor: "#fff",
                        fontSize: "13px",
                        border: "1px solid #eee",
                        boxShadow: "1px 2px 3px #555",
                      },
                    },
                  }}
                  >
                <img
                    key={userGivenFeedbackType === 1 ? voteVersion : 0}
                    alt = "image for the disaggree "
                    className={hasUserLiked && userGivenFeedbackType === 1 ? voteClasses["vote-bump"] : undefined}
                    style={styles.icon}
                    src={ hasUserLiked && userGivenFeedbackType === 1 ? thumps_down_filled : thumps_down}
                />
                </Tooltip>
                <span style={styles.count}>{ providerComment.providerLikeFeedbackSummary ? (providerComment?.providerLikeFeedbackSummary?.disagreeCount) : "0" }</span>
            </button>

            <button
                className={voteClasses["vote-button"]}
                style={styles.button}
                onClick={() => handleButtonclick(2)}
            >
                <Tooltip
                 title = "Agree with Rating"

                 componentsProps={{
                    tooltip: {
                      sx: {
                        color: "black",
                        backgroundColor: "#fff",
                        fontSize: "13px",
                        border: "1px solid #eee",
                        boxShadow: "1px 2px 3px #555",
                      },
                    },
                  }}
                  >
                 <img
                    key={userGivenFeedbackType === 2 ? voteVersion : 0}
                    alt = "image for the aggree "
                    className={hasUserLiked && userGivenFeedbackType === 2 ? voteClasses["vote-bump"] : undefined}
                    style={styles.icon}
                    src={hasUserLiked && userGivenFeedbackType === 2 ? thumps_up_filled : thumps_up}
                 />
                </Tooltip>
                <span style={styles.count}>{ providerComment?.providerLikeFeedbackSummary !== undefined ? providerComment?.providerLikeFeedbackSummary?.agreeCount : "0" }</span>
            </button>

            <button
                className={voteClasses["vote-button"]}
                style={styles.button}
                onClick={() => handleButtonclick(3)}
            >
                <Tooltip
                 title = "Definetly Agree with Rating"

                 componentsProps={{
                    tooltip: {
                      sx: {
                        color: "black",
                        backgroundColor: "#fff",
                        fontSize: "13px",
                        border: "1px solid #eee",
                        boxShadow: "1px 2px 3px #555",
                      },
                    },
                  }}
                  >
                <img
                    key={userGivenFeedbackType === 3 ? voteVersion : 0}
                    alt = "image for the strongly aggree "
                    className={hasUserLiked && userGivenFeedbackType === 3 ? voteClasses["vote-bump"] : undefined}
                    style={styles.icon}
                    src={ hasUserLiked && userGivenFeedbackType === 3 ? thumps_up_double_filled : thumps_up_double}
                />
                </Tooltip>
                <span style={styles.count}>{providerComment?.providerLikeFeedbackSummary !== undefined  ?   (providerComment?.providerLikeFeedbackSummary?.stronglyAgreeCount)  : "0" }</span>
            </button>

        </div>
    )
}

const styles = {
    buttonGroup: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "6px",
        flexWrap: "wrap",
    },
    button: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        border: "0.5px solid var(--line-strong, rgba(60,60,67,0.22))",
        borderRadius: "999px",
        padding: "5px 10px",
        cursor: "pointer",
        color: "var(--ink-2, #6e6e73)",
        background: "var(--surface, #fff)",
        fontSize: "12px",
        fontWeight: 500,
    },
    icon: {
        width: "14px",
        height: "14px",
        display: "block",
    },
    count: {
        fontWeight: 600,
        lineHeight: 1,
    },

};

export default LikeDislike;